import { Api } from '../services/api.service';
import type { ApiConfig } from '../models/api-config.model';

export function createApi<TModules = any>(options: ApiConfig<TModules>): Api<TModules> {
  return new Api(options.config, options.modules);
}
